import _ from 'lodash'
import type { IWixCodeNamespacesRegistry, InvokeNamespaceHandler, BiUtils } from '@wix/thunderbolt-symbols'
import { Logger as ApiInfraLogger } from '@wix/bi-logger-api-infra-data'
import {
	BOOTSTRAP_DATA,
	CLIENT_SDK,
	VIEWER_HANDLERS,
	WIX_CODE_NAMESPACES_REGISTRY,
	PLATFORM_BI_LOGGER,
} from './moduleNames'
import type { IViewerHandlers } from '../types'
import type { BootstrapData } from '../../types'

export type IClientSdk = {
	load: () => void
}

const ClientSdk = (
	{ viewerHandlers }: IViewerHandlers,
	wixCodeNamespacesRegistry: IWixCodeNamespacesRegistry,
	bootstrapData: BootstrapData,
	platformBiLogger: BiUtils
): IClientSdk => {
	const biLogger = new ApiInfraLogger(platformBiLogger.createBaseBiLoggerFactory())

	const deserializeArguments = (argsToDeserialize: Array<any>) => {
		return argsToDeserialize.map((serializedArg) => {
			if (serializedArg?.__client_sdk_type__ === 'function') {
				const functionId = serializedArg.id
				return (...wrappedFnArgs: Array<any>) => {
					return viewerHandlers.clientSdk.invokeProxyFunction(functionId, wrappedFnArgs)
				}
			}

			return serializedArg
		})
	}

	return {
		load: () => {
			const { isSSR } = bootstrapData.platformEnvData.window

			if (isSSR) {
				return
			}

			const invokeHandler: InvokeNamespaceHandler = ({ applicationId, namespace, method, args }) => {
				void biLogger.veloNamespacesInvocationSrc72Evid521({ app_id: applicationId, namespace, method })

				const namespaceApi = wixCodeNamespacesRegistry.get(namespace, applicationId)
				if (!namespaceApi) {
					throw new Error(`namespace ${namespace} is not registered for appDefinitionId ${applicationId}`)
				}

				const fn = _.get(namespaceApi, method)
				if (!fn) {
					throw new Error(`method ${method} is not registered in namespace ${namespace}`)
				}

				if (typeof fn === 'function') {
					const deserializedArgs = deserializeArguments(args)
					return fn(...deserializedArgs)
				}

				return fn
			}

			viewerHandlers.clientSdk.onPlatformReady(invokeHandler)
		},
	}
}

export default {
	factory: ClientSdk,
	deps: [VIEWER_HANDLERS, WIX_CODE_NAMESPACES_REGISTRY, BOOTSTRAP_DATA, PLATFORM_BI_LOGGER],
	name: CLIENT_SDK,
}
